export default '/src/assets/webgl/caris_2/audios/en/bundle_1.mp3'